<template>
  <div
    class="simple-confirm"
    :class="{ show: dialog }"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <div class="simple-content">
      <div class="simple-header">
        <h2>{{ title }}</h2>
      </div>
      <div class="simple-body" v-show="!!message" v-html="message"></div>
      <div class="simple-footer" style="text-align: right">
        <button class="simple-button" :class="options.cancelClass" v-if="!options.noconfirm" text @click="cancel">
          {{ options.cancelText }}
        </button>
        <button class="simple-button" :class="options.agreeClass" outlined @click="agree">
          {{ options.agreeText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleConfirm',
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: 'grey lighten-3',
        width: 400,
        zIndex: 200,
        noconfirm: false,

        agreeText: 'OK',
        agreeClass: 'agree',

        cancelText: 'Cancel',
        cancelClass: 'cancel',
      },
    };
  },
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.simple-confirm {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}
.simple-confirm.show {
  display: block;
}
.simple-content {
  background-color: #fefefe;
  margin: 15% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 40%;
}

.simple-body {
  margin-top: 15px;
  margin-bottom: 15px;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.simple-button {
  position: relative;
  background-color: #ffffff;
  color: #1c2731;
  border: none;
  color: #ffffff;
  padding: 0.5em 1em;
  width: auto;
  text-align: center;
  transition-duration: 0.4s;
  text-decoration: none;
  overflow: hidden;
  cursor: pointer;
}
.simple-button.dark {
  background-color: #1c2731;
  color: #ffffff;
}
.simple-button.agree {
  background-color: #15a04f;
  color: #ffffff;
}
.simple-button.cancel {
  background-color: #b21a1a;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/simpleConfirm/SimpleConfirm.vue